import React from "react";
import port from "../images/port.webp";
import "../App.css";
function Home() {
  return (
    <>
      <section className="flex justify-around items-center flex-wrap mt-10 m-auto md:mt-16">
        <div className="text-2xl md:text-4xl md:w-96">
          <div className="m-auto md:pt-6 md:pl-2">
            <h2 className="pb-3 animate-bounce">
              Hello<span className="hi">👋</span>
            </h2>
            <h2 className="pb-3">I'm Akshay Kumar</h2>
            <div>
              <h2 class="animate-typing overflow-hidden whitespace-nowrap border-r-1 pr-5">
                <span class="kesriya">Front</span>{" "}
                <span class="text-white">End</span>{" "}
                <span class="hara">Developer</span>
              </h2>
            </div>
            {/* GitHub account */}
            <a
              href="https://github.com/akshay7272"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="pr-8 pt-10 hover:text-white hover:animate-pulse">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  className="icon"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"></path>
                </svg>
              </button>
            </a>
            {/* linkedin account */}
            <a
              href="https://www.linkedin.com/in/akshay-kumar-069360257/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="hover:text-white hover:animate-pulse">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  className="icon"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              src={port}
              className=" object-contain mt-5 h-96"
              alt=""
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
